import { render, staticRenderFns } from "./categorylist.vue?vue&type=template&id=6cf82c62&scoped=true"
import script from "./categorylist.vue?vue&type=script&lang=js"
export * from "./categorylist.vue?vue&type=script&lang=js"
import style0 from "./categorylist.vue?vue&type=style&index=0&id=6cf82c62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf82c62",
  null
  
)

export default component.exports